import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['vaccine', 'conflictModal'];

  lastSelectedTarget = null;

  onVaccineClick(event) {
    if (this.featureEnabled()) {
      const element = event.target;
      this.lastSelectedTarget = element;
      if (element.checked && this.conflictsWithAnotherVaccine(element)) {
        this.conflictModalTarget.classList.toggle('hidden');
      }
    }
  }

  conflictsWithAnotherVaccine(vaccine) {
    const relatedCvxCodes = JSON.parse(vaccine.dataset.relatedCvxCodes);
    const withConflicts = this.selectedVaccines(vaccine)
      .filter((selectedVaccine) => relatedCvxCodes.includes(selectedVaccine.dataset.cvxCode));

    return withConflicts.length > 0;
  }

  selectedVaccines(toExclude) {
    return this.vaccineTargets.filter((vaccine) => vaccine.checked && vaccine !== toExclude);
  }

  closeModal() {
    this.conflictModalTarget.classList.toggle('hidden');
  }

  cancelSelection() {
    this.lastSelectedTarget.click();
    this.closeModal();
  }

  featureEnabled() {
    return this.element.dataset.alertusersonsamevaccinefamilyinpatientencounterbox === 'true';
  }
}
